export default __webpack_public_path__ + "static/media/missed-school-icon.8262257e.svg";